<div class="connection-edit">
  <header class="connection-edit__header">
    <button type="button" class="connection-edit__back-tab" (click)="backToConnections()">
      <i class="ms-Icon ms-Icon--Back" aria-hidden="true"></i>
      <span>Connections</span>
    </button>

    @if (connection) {
      <div class="connection-edit__title">
        <h1>{{ connection.displayName || connection.name }}</h1>
        <p>{{ connection.environment }} / {{ connection.name }}</p>
      </div>
    } @else {
      <div class="connection-edit__title">
        <h1>Connection</h1>
      </div>
    }

    <nav class="connection-edit__tabs" aria-label="Connection edit tabs">
      <button type="button" class="active" disabled>
        <i class="ms-Icon ms-Icon--PlugConnected" aria-hidden="true"></i>
        <span>Connection</span>
      </button>
      <button type="button"
        [disabled]="!connection?.connector"
        (click)="viewConnector()"
        [title]="connection?.connector ? ('View connector: ' + connection.connector) : 'No connector linked'">
        <i class="ms-Icon ms-Icon--PlugDisconnected" aria-hidden="true"></i>
        <span>Connector</span>
      </button>
    </nav>
  </header>

  @if (error) {
    <div class="connection-edit__error">{{ error }}</div>
  }

  @if (connection && !loading) {
    <section class="connection-edit__panel">
      <app-flow-detail [editorType]="'Connection'" [connection]="connection"></app-flow-detail>
    </section>
  } @else {
    @if (loading) {
      <div class="connection-edit__loading">Loading…</div>
    }
  }

</div>
